import React from 'react'
import { MANTHLY_INCOME_QUARTERLY_ITEM_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ManthlyIncomeQuarterlyItemForm from './ManthlyIncomeQuarterlyItemForm'

export default function ManthlyIncomeQuarterlyItemUpdate({ onCancel, onSuccess, reportItem, finance, incomeQuarterlyId }) {
    const url = MANTHLY_INCOME_QUARTERLY_ITEM_DETAIL.replace('{id}', reportItem.id)
    const incomeQuarterlyItemUpdate = usePutRequest({ url })

    async function onSubmit(data) {
        const { success } = await incomeQuarterlyItemUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Изменить данные</b><br /><br />
            <ServerError error={incomeQuarterlyItemUpdate.error} />
            <ManthlyIncomeQuarterlyItemForm
                initialValues={reportItem}
                onSubmit={onSubmit}
                onCancel={onCancel}
                incomeQuarterlyId={incomeQuarterlyId}
                finance={finance}
                loading={incomeQuarterlyItemUpdate.loading} />
        </div>
    )
}
